// Module
var code = "<div class=\"c-landingPage\">\n    <div class=\"c-landingPage-widget\" ng-repeat=\"widgetData in $ctrl.widgets track by $index\">\n        <landing-page-custom-widget user-context=\"$ctrl.userContext\" widget-data=\"widgetData\">\n        </landing-page-custom-widget>\n    </div>\n</div>\n";
// Exports
module.exports = code;